
var id = "remove";
var markup = "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"remove\"><path d=\"M725.418667 725.333333c-11.52 0-22.613333-4.693333-30.293334-12.373333a42.410667 42.410667 0 0 1-0.426666-60.373333v-0.426667l97.578666-96.981333H231.381333l97.493334 96.938666a42.282667 42.282667 0 0 1 0 59.989334h-0.426667c-8.106667 7.68-19.2 12.330667-30.293333 12.330666l0.853333 0.853334c-11.52 0-22.613333-4.650667-30.293333-12.288l-170.538667-170.154667a42.410667 42.410667 0 0 1-0.426667-60.416v-0.426667L268.373333 311.850667a42.325333 42.325333 0 0 1 60.544-0.042667c16.64 16.597333 16.64 43.392 0 60.416L230.4 470.101333h562.645333l-98.346666-97.834666v-0.426667a42.069333 42.069333 0 0 1 0-60.416 42.282667 42.282667 0 0 1 60.544 0l170.581333 170.154667a40.96 40.96 0 0 1 10.709333 17.792 42.624 42.624 0 0 1-18.773333 49.749333l-162.944 162.602667c-8.106667 7.68-19.2 12.373333-30.293333 12.373333l0.853333 1.237333z\" p-id=\"20045\" /></symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
